import React from "react";
import logoImage from "../../assets/BigLogo.png";
import vectorImageSun from "../../assets/Vector (Stroke).png";
import vectorImageLandscape from "../../assets/Vector (Stroke) (1).png";
import frameCottage from "../../assets/Frame 43.png";
import SectionHeader from "./SectionHeader";
import Typography from "@mui/material/Typography";
import {Box} from "@mui/system";

const style = {
  mainContainer: {
    width: "100%",
    backgroundColor: "#FBF7F3",
    boxSizing: "border-box",
    paddingTop: {
      xl: "0px",
      lg:'0px',
      md: "70px",
      sm: "50px",
      xs: "50px",
    },
    height: {
      xs: "auto",
      sm: "auto",
      md: "auto",
      lg: "865px",
      xl: "865px",
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    
  },
  innerWrapper: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: 10,
    margin: "50px 0",
    
  },
  logoWrapper: {
    // width: { xs: "320px", sm: "430px" },
    maxHeight: "460px",
    

    maxWidth: "430px",
    // height: { xs: "310px", sm: "460px" },
    border: "1px solid #B8772A",
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    // width: { xs: "196px", sm: "318px" },
    width: "100%",
    maxWidth: "318px",
    padding: 10,
    // height: { xs: "186px", sm: "301px" },
  },
  contentWrapper: {
    // width: { xs: "305px", sm: "430px" },
    maxWidth:"430px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: 10,
    
  },
  title: {
    fontFamily: "ZapfHumnst BT",
    fontSize: { xs: "16px", sm: "34px" },
    fontWeight: 400,
    color: "rgba(24, 24, 24, 1)",
    lineHeight: { xs: "19.8px", sm: "42px" },
    letterSpacing: { xs: "3%" },
  },
  description: {
    fontFamily: "sora",
    fontSize: { xs: "11px", sm: "14px" },
    fontWeight: 350,
    color: "rgba(68, 84, 91, 1)",
    marginTop: "8px",
    lineHeight: { xs: "18px", sm: "20px" },
    letterSpacing: { xs: "1%" },
  },
};

const LogoStory = () => {
  const destinations = [
    {
      title: "The Sun",
      description:
        "The sun, positioned approximately 93 million  miles away from Earth, generously provides energy to sustain life on our planet.",
      icon: vectorImageSun,
    },
    {
      title: "The Landscape",
      description:
        "Its radiant light rays grace the surface, filling the surroundings with joy and warmth.",
      icon: vectorImageLandscape,
    },
    {
      title: "The Cottage",
      description:
        "Where blissful relaxation awaits you in our charming and cozy cottages.",
      icon: frameCottage,
    },
  ];
  return (
    <Box sx={style.mainContainer}>
      <SectionHeader
        title={"Our Logo Story"}
        description={"Our Signature Mark"}
      />
      <Box sx={style.innerWrapper}>
        <Box sx={style.logoWrapper}>
          <Box sx={style.logo}>
            <img width={"100%"} height={"100%"} src={logoImage} alt="logo" />
          </Box>
        </Box>
        <Box sx={style.contentWrapper}>
          {destinations.map((item, index) => (
            <Box
              key={index}
              display={"flex"}
              gap={5}
              sx={{
                height: {
                  xs: "108px",
                  sm: "107px",
                },
                paddingRight:'1rem',
                paddingLeft:"1rem"
              }}
            >
              <img src={item.icon} alt="" />
              <Box display={"flex"} flexDirection={"column"}>
                <Typography sx={style.title}>{item.title}</Typography>
                <Typography sx={style.description}>
                  {item.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default LogoStory;
